import http from "./http";
import config from "../common/config";

/*
* 应收账款接口
* project-receive-controller
* 图片1.1接口
* */
// 删除对应录入日期的应收数据
const deleteAllReceive = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.delete('financedemo-web/receive/deleteAll', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
// 确认导入应收账款，会将该录入日期覆盖
const doImportReceive = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('financedemo-web/receive/doImport?enterDate='+ reqParam.enterDate, reqParam.projectReceiveVOList, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 导出应收账款
const exportReceive = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/receive/export', reqParam).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
// 获取最大有效日期
const getMaxDateReceive = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/receive/getMaxDate', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
// 导入应收账款
const importReceive = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('financedemo-web/receive/import', reqParam, false,false,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 查询应收数据
const getListReceive = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/receive/list', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};


/*
* 应付账款接口
* project-pay-controller
* 图片1.2接口
* */

// 删除对应录入日期的应付数据
const deleteAllPay = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.delete('financedemo-web/pay/deleteAll', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
// 确认导入应付账款，会将该录入日期覆盖
const doImportPay = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('financedemo-web/pay/doImport?enterDate='+reqParam.enterDate, reqParam.projectPayVOList, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 导出应付账款
const exportPay = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/pay/export', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};

// 获取最大有效日期
const getMaxDatePay = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/pay/getMaxDate', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};

// 导入应付账款
const importPay = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.post('financedemo-web/pay/import', reqParam, false,false,true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

// 查询应付数据
const getListPay = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/pay/list', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};

/*
* 应收账款接口
* receive-analysis-controller
* 图片2.接口
* */
//应收账款统计
const getReceiveAnalysisAuditAmount = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/receive/analysis/auditAmount', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//项目部看板
const getReceiveAnalysisAuditAmountDept = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/receive/analysis/auditAmount/dept', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//项目看板
const getReceiveAnalysisAuditAmountProject = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/receive/analysis/auditAmount/project', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//获取最大有效日期
const getReceiveMaxDate = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/receive/getMaxDate', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//项目部下拉
const getReceiveDropDownDept = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/receive/dropDown/dept', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//项目下拉
const getReceiveDropDownProject = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/receive/dropDown/project', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
/*
* 付款申请接口
* pay-analysis-controller
* 图片3.接口
* */
//付款申请首页统计
const getPayAnalysis = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/pay/analysis', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//项目部看板
const getPayAnalysisDept = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/pay/analysis/dept', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//项目看板
const getPayAnalysisProject = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/pay/analysis/project', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//获取最大有效日期
const getPayMaxDate = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/pay/getMaxDate', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//项目部下拉
const getPayDropDownDept = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/pay/dropDown/dept', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};
//项目下拉
const getPayDropDownProject = (reqParam) => {
    return new Promise((resolve, reject) => {
        http.get('financedemo-web/pay/dropDown/project', reqParam, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
};

//导入应收账款数据源接口
const uploadProjectReceiveService = param => {
    return new Promise((resolve, reject) => {
      http
        .post(
         "financedemo-web/receive/import",
          param,
          false,
          false,
          true
        )
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  };
  
  
  //确认导入应收账款数据源接口
  const confirmuploadProjectReceiveService = param => {
    return new Promise((resolve, reject) => {
      http
        .post(
          "financedemo-web/receive/doImport",
          param,
          false      
        )
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  //导入应付账款数据源接口
const uploadProjectPayService = param => {
    return new Promise((resolve, reject) => {
      http
        .post(
          "financedemo-web/pay/import",
          param,
          false,
          false,
          true
        )
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  };
  
  
  //确认导入应付账款数据源接口
  const confirmProjectPayService = param => {
    return new Promise((resolve, reject) => {
      http
        .post(
          "financedemo-web/pay/doImport",
          param,
          false      
        )
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  };
  const exportExcelService2 = (url, param, needTrim = true) => {
    let baseUrl = config.baseUrl + "/contract-web";
    return new Promise((resolve, reject) => {
      //let exportUrl = `${baseUrl}${url}?`;
      let exportUrl = url;
      // for (let key in param) {
      //     if (param[key]) {
      //         exportUrl += `${/\?$/.test(exportUrl) ? '' : '&'}${key}=${encodeURI(param[key])}`;
      //         console.log(exportUrl)
      //     }
      // }
      try {
        var elemIF = document.createElement("iframe");
        elemIF.src = needTrim ? exportUrl.replace(/\s*/g, "") : exportUrl;
        elemIF.style.display = "none";
        document.body.appendChild(elemIF);
        let self = this;
        elemIF.onload = function() {
          reject();
        };
      } catch (e) {
        console.error(e);
      }
    });
  };

  //getTemplate下载应收账款模板
const getReceiveTemplate = param => {
    return new Promise((resolve, reject) => {
      http
        .get("financedemo-web/oss/template/receive", {"category":param})
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  };
//下载应付账款模板
  const getPayTemplate = param => {
    return new Promise((resolve, reject) => {
      http
        .get("financedemo-web/oss/template/pay", {"category":param})
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  };
export {
    exportExcelService2,
    getReceiveTemplate,
    getPayTemplate,
    //应收账款接口
    deleteAllReceive,
    doImportReceive,
    exportReceive,
    getMaxDateReceive,
    importReceive,
    getListReceive,
    //应付账款
    deleteAllPay,
    doImportPay,
    exportPay,
    getMaxDatePay,
    importPay,
    getListPay,
    //应付帐单接口
    getReceiveAnalysisAuditAmount,
    getReceiveAnalysisAuditAmountDept,
    getReceiveAnalysisAuditAmountProject,
    getReceiveMaxDate,
    getReceiveDropDownDept,
    getReceiveDropDownProject,
    //导入相关接口
    uploadProjectReceiveService,
    confirmuploadProjectReceiveService,
    uploadProjectPayService,
    confirmProjectPayService,
    //付款申请接口
    getPayAnalysis,
    getPayAnalysisDept,
    getPayAnalysisProject,
    getPayMaxDate,
    getPayDropDownDept,
    getPayDropDownProject
}
